import React, { FC, useCallback } from 'react';

import { useIntl } from 'react-intl';

import useUserVerification from 'hooks/use-user-verification';
import { toast } from 'utils/toast';

import { Button, Container, Instructions } from './user-verification.styled';

const UserVerification: FC = () => {
  const { formatMessage } = useIntl();
  const { sendVerificationEmail, loading } = useUserVerification();
  const onVerify = useCallback(
    async event => {
      event.preventDefault();
      await sendVerificationEmail();
      toast.success(formatMessage({ id: 'emailVerificationSent' }));
    },
    [formatMessage, sendVerificationEmail]
  );
  return (
    <Container data-testid="user-verification">
      <Instructions>
        {formatMessage({
          id: 'verifyYourEmailInstructions',
        })}
      </Instructions>
      <Button isLoading={loading} onClick={onVerify} data-testid="user-verification-verify-button">
        {formatMessage({
          id: 'verifyYourEmail',
        })}
      </Button>
    </Container>
  );
};

export default UserVerification;
